import SalesOverview from '../../features/sales/layouts/overview';

// TSS vite/01 §"Pages are thin". /admin/sales — Negocios · ventas de crías.
export default function SalesPage() {
    return <SalesOverview />;
}
